export const setGlobalCountry = (response: any) => {
  return {
    type: "SET_GLOBAL_COUNTRY",
    payload: response,
  };
};
